import { useQuery } from "@tanstack/react-query"
import { getAllSections } from "../../../api/projects/getAllSections"

export const useGetAllSections = () => {

  return useQuery({
    queryKey: ['allSections'],
    queryFn: getAllSections,
    staleTime: 1000 * 60 * 60,
    retry: 1
  })
}
